import React from 'react';
import './KycLegalType.css';

const OPTIONS = [
  {
    value: 'sole_proprietor',
    title: 'Sole proprietor',
    copy: 'Optional. Upload your IRA licence below.'
  },
  {
    value: 'business_entity',
    title: 'Business entity',
    copy: 'Optional. Enter the business name if you want it on file. Only the IRA licence is needed.'
  }
];

const KycLegalTypePicker = ({
  legalType,
  businessName,
  onLegalTypeChange,
  onBusinessNameChange,
  showSave = false,
  onSave,
  saving = false,
  disabled = false
}) => {
  const canSave = !!legalType && (legalType !== 'business_entity' || String(businessName || '').trim());

  return (
    <div className="kyc-legal-picker">
      <h3>What type of agent are you?</h3>
      <p className="kyc-legal-help">
        Agent type is optional. Upload your IRA licence below. Extra documents already on your account are kept.
      </p>
      <div className="kyc-legal-options" role="radiogroup" aria-label="Agent type">
        {OPTIONS.map((option) => {
          const selected = legalType === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`kyc-legal-card${selected ? ' selected' : ''}`}
              onClick={() => onLegalTypeChange(option.value)}
              disabled={disabled}
            >
              <span className="kyc-legal-title">{selected ? '● ' : '○ '}{option.title}</span>
              <span className="kyc-legal-copy">{option.copy}</span>
            </button>
          );
        })}
      </div>
      {legalType === 'business_entity' && (
        <div className="kyc-legal-business">
          <label htmlFor="kyc-business-name">Name of business *</label>
          <input
            id="kyc-business-name"
            type="text"
            value={businessName || ''}
            onChange={(e) => onBusinessNameChange(e.target.value)}
            placeholder="Business name (optional)"
            disabled={disabled}
            autoComplete="organization"
          />
        </div>
      )}
      {showSave && (
        <button
          type="button"
          className="kyc-legal-save"
          onClick={onSave}
          disabled={disabled || saving || !canSave}
        >
          {saving ? 'Saving...' : 'Save KYC details'}
        </button>
      )}
    </div>
  );
};

export default KycLegalTypePicker;
